<template>
	<v-card elevation="3">
		<form @submit.prevent>
			<v-card-title primary-title>
				{{ title }}
				<v-spacer></v-spacer>
				<v-btn
					icon
					@click="$emit('close'); itemId = null; $refs.table.resetInputs()"
				>
					<v-icon color="alert-color">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-row dense>
					<v-col cols="12">
						<bee-handy-smart-table
							ref="table"
							v-model="inputs"
							:headers="headers"
							:items="items"
							@keypress.enter="add"
							:items-per-page="-1"
							:loading="loading"
							dense
							elevation="1"
							editable-rows
							hide-no-data-area
							show-add-row
							hide-default-footer
							fixed-header
							hide-inputs-details>
							<template v-slot:item.actions="{ item, index }">
								<div class="d-flex">
									<tooltip :text="$T('tooltips.edit')">
										<v-btn
											depressed
											rounded
											icon
											small
											@click="
												$refs.table.activeEditForRow(index);
												itemId = item.id;
											">
											<v-icon
												size="20"
												color="edit-color">
												$edit
											</v-icon>
										</v-btn>
									</tooltip>
								</div>
							</template>
							<template v-slot:no-input.actions="{}">
								<tooltip
									:text="$T('tooltips.addRow')"
									:disabled="!inputs.name">
									<v-btn
										:disabled="!inputs.name"
										:loading="loadingAdding"
										depressed
										rounded
										icon
										small
										color="success"
										@click="add">
										<v-icon
											size="20"
											color="addRow">
											{{ 'mdi-check-circle-outline' }}
										</v-icon>
									</v-btn>
								</tooltip>
							</template>
						</bee-handy-smart-table>
					</v-col>
				</v-row>
			</v-card-text>
		</form>
	</v-card>
</template>

<script>
export default {
	props: {
		headers: { type: Array },

		fetchStore: { type: String },
		addStore: { type: String },
		title: { type: String },
	},

	data() {
		return {
			loading: false,
			loadingAdding: false,

			items: [],

			itemId: null,

			inputs: {},
		};
	},

	computed: {
		payload() {
			const arr = {};
			this.headers.forEach((e) => {
				if (e.storeName) {
					arr[e.storeName] = this.inputs[e.name];
				}
			});

			return arr;
		},
	},

	methods: {
		fetch() {
			this.loading = true;
			this.$store
				.dispatch(this.fetchStore)
				.then((res) => {
					this.items = res;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		add() {
			this.loadingAdding = true;
			this.$store
				.dispatch(this.addStore, { id: this.itemId, ...this.payload })
				.then(() => {
					this.$eventBus.$emit(
						'show-snackbar',
						!this.itemId ? this.$T('messages.add-done') : this.$T('messages.edit-done'),
						{ done: true }
					);
					this.$refs.table.resetEdit();
					this.$refs.table.resetInputs();
					this.fetch();
					this.itemId = null;
				})
				.catch((err) => {
					err.default && err.default(
						!this.itemId ? this.$T('messages.add-fail') : this.$T('messages.edit-fail'),
						false
					);
				})
				.finally(() => {
					this.loadingAdding = false;
				});
		},
	},

	mounted() {
		this.fetch();
	},
};
</script>

<style lang="scss" scoped></style>
